import React from "react"

export default function ConversionTable({ stages = [] }) {
  if (!stages.length) return null

  return (
    <div className="rounded-lg border border-slate-200 bg-white overflow-hidden">
      <div className="px-4 py-3 text-[13px] font-medium text-slate-700">Stage Conversion</div>
      <table className="w-full text-[13px]">
        <thead className="bg-slate-50 text-left text-slate-500">
          <tr>
            <th className="px-4 py-2.5 font-medium">Stage</th>
            <th className="px-4 py-2.5 font-medium text-right">Reached</th>
            <th className="px-4 py-2.5 font-medium text-right">Converted</th>
            <th className="px-4 py-2.5 font-medium text-right">Rate</th>
            <th className="px-4 py-2.5 font-medium text-right">Avg Days</th>
            <th className="px-4 py-2.5 font-medium w-32">Progress</th>
          </tr>
        </thead>
        <tbody>
          {stages.map((s) => (
            <tr key={s.stage_id} className="border-t border-slate-100">
              <td className="px-4 py-2.5 text-slate-900 font-medium">{s.name}</td>
              <td className="px-4 py-2.5 text-right">{s.reached}</td>
              <td className="px-4 py-2.5 text-right">{s.converted_to_next ?? "—"}</td>
              <td className="px-4 py-2.5 text-right">
                {s.conversion_rate != null ? `${s.conversion_rate}%` : "—"}
              </td>
              <td className="px-4 py-2.5 text-right">
                {s.avg_days_in_stage != null ? `${s.avg_days_in_stage}d` : "—"}
              </td>
              <td className="px-4 py-2.5">
                {s.conversion_rate != null && (
                  <div className="h-2 w-full rounded-full bg-slate-100">
                    <div
                      className="h-2 rounded-full bg-indigo-500"
                      style={{ width: `${Math.min(s.conversion_rate, 100)}%` }}
                    />
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
